/**
 * @generated SignedSource<<d6b0dd0bdeabfafe484c88a6864955a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type workItemsTable_AtlassianConversationAssistantPreviewCard_Row_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"rowActions_AtlassianConversationAssistantPreviewCard">;
  readonly " $fragmentType": "workItemsTable_AtlassianConversationAssistantPreviewCard_Row_project";
};
export type workItemsTable_AtlassianConversationAssistantPreviewCard_Row_project$key = {
  readonly " $data"?: workItemsTable_AtlassianConversationAssistantPreviewCard_Row_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"workItemsTable_AtlassianConversationAssistantPreviewCard_Row_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_Row_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "rowActions_AtlassianConversationAssistantPreviewCard"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "eb5bc0ec6c01815099a03cf046cf04b8";

export default node;
